import type { Category, FaqItem, Voice } from "@/types/news";

export const siteInfo = {
  name: "蝌蚪爆料",
  slogan: "追踪发酵全过程，吃瓜不被带节奏",
  intro:
    "蝌蚪爆料关注网络热议事件的进展脉络，把「怎么火的、吵什么、谁回应了、哪些是谣言」按时间整理清楚，让你花几分钟看完重点。",
  email: "hello@kedoubaoliao.cn",
  tipEmail: "xiansuo@kedoubaoliao.cn",
  weibo: "@蝌蚪爆料",
  since: "2021",
};

export const navLinks: { label: string; to: string }[] = [
  { label: "首页", to: "/" },
  { label: "热议追踪", to: "/category/reyi" },
  { label: "争议焦点", to: "/category/zhengyi" },
  { label: "辟谣核查", to: "/category/piyao" },
  { label: "舆论观察", to: "/category/guancha" },
  { label: "关于我们", to: "/about" },
  { label: "联系我们", to: "/contact" },
];

export const categories: Category[] = [
  {
    slug: "reyi",
    name: "热议追踪",
    short: "追踪",
    desc: "记录一件热点从冒头到刷屏的关键节点，按时间线还原发酵过程。",
    icon: "ri-fire-line",
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20editorial%20abstract%20illustration%20of%20rising%20warm%20ember%20flames%20and%20concentric%20ripples%20on%20cream%20paper%20texture%2C%20vermilion%20and%20amber%20palette%2C%20soft%20grain%2C%20flat%20design%2C%20no%20text&width=900&height=600&seq=kb-cat-reyi-01&orientation=landscape",
  },
  {
    slug: "zhengyi",
    name: "争议焦点",
    short: "争议",
    desc: "把双方或多方吵的到底是什么拆开讲，聚焦争议核心而不是情绪对骂。",
    icon: "ri-scales-3-line",
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20editorial%20abstract%20illustration%20of%20balanced%20scales%20and%20geometric%20blocks%20on%20cream%20paper%20texture%2C%20warm%20red%20and%20amber%20palette%2C%20soft%20grain%2C%20flat%20design%2C%20no%20text&width=900&height=600&seq=kb-cat-zhengyi-01&orientation=landscape",
  },
  {
    slug: "piyao",
    name: "辟谣核查",
    short: "核查",
    desc: "对流传的说法逐条比对公开信息，给出「属实 / 不实 / 部分属实 / 暂无定论」的核查结论。",
    icon: "ri-shield-check-line",
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20editorial%20abstract%20illustration%20of%20a%20shield%20with%20a%20check%20mark%20and%20document%20pages%20on%20cream%20paper%20texture%2C%20muted%20olive%20green%20and%20amber%20palette%2C%20soft%20grain%2C%20flat%20design%2C%20no%20text&width=900&height=600&seq=kb-cat-piyao-01&orientation=landscape",
  },
  {
    slug: "guancha",
    name: "舆论观察",
    short: "观察",
    desc: "看评论风向怎么变、话题怎么被带偏，分析传播路径与信息偏差。",
    icon: "ri-radar-line",
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20editorial%20abstract%20illustration%20of%20radar%20waves%20and%20data%20bars%20on%20cream%20paper%20texture%2C%20warm%20terracotta%20and%20amber%20palette%2C%20soft%20grain%2C%20flat%20design%2C%20no%20text&width=900&height=600&seq=kb-cat-guancha-01&orientation=landscape",
  },
];

export const generalFaqs: FaqItem[] = [
  {
    q: "蝌蚪爆料的内容是从哪里来的？",
    a: "我们主要整理公开可查的信息：当事方或其团队的公开声明、主流媒体的报道、平台官方公告以及权威机构的说明。每条进展都会尽量标注时间与来源类型，方便你自己核对。",
  },
  {
    q: "「辟谣核查」的结论是怎么给的？",
    a: "核查会把流传的说法拆成一句句可验证的命题，再去比对公开材料，最后给出「属实」「不实」「部分属实」或「暂无定论」四种结论之一。信息不足时我们会明确写「暂无定论」，而不是硬下判断。",
  },
  {
    q: "为什么有的热点追踪到一半就不再更新了？",
    a: "当事件没有新进展、或公开信息无法进一步核实的时候，页面会进入「观望」状态并保留最后更新时间，避免用猜测填充时间线。一旦有新回应或新证据，会重新更新。",
  },
  {
    q: "我不想被情绪带着走，你们能帮上什么？",
    a: "每个事件页都会把「争议焦点」和「当事方回应」分开列出，并给出评论风向的大致比例，让你先看清各方在争什么，再决定自己怎么看，而不是只看最激烈的那几句。",
  },
  {
    q: "可以给你们提供线索或纠错吗？",
    a: "可以。我们欢迎提供线索、补充材料或指出内容错误。你可以在「联系我们」页面提交，尽量附上可公开核实的信息来源，方便我们快速处理。",
  },
  {
    q: "你们的更新频率是怎样的？",
    a: "处于「追踪中」的热点会优先更新，通常在有新回应、新公告或新证据后尽快刷新；「已核实」或「已平息」的事件只在出现重大变化时更新。",
  },
];

export const voices: Voice[] = [
  {
    name: "林一舟",
    role: "长期读者",
    text: "最省心的就是时间线，一件事隔了两天再刷到，先看蝌蚪的时间线就知道中间发生了什么，不用翻几十条动态。",
  },
  {
    name: "周小满",
    role: "内容从业者",
    text: "辟谣核查那一块做得比较克制，写「暂无定论」的时候也不硬编，这点挺难得。",
  },
  {
    name: "陈屿",
    role: "普通网友",
    text: "以前吃瓜容易被带节奏，现在会先看争议焦点到底是哪几条，看完再聊，心态稳多了。",
  },
];

export const principles: { icon: string; title: string; desc: string }[] = [
  {
    icon: "ri-time-line",
    title: "按时间讲清楚",
    desc: "不堆情绪、不追热词，按发生顺序还原一件事的来龙去脉。",
  },
  {
    icon: "ri-link-m",
    title: "结论有出处",
    desc: "关键判断标注公开信息来源类型，能自己查证的绝不替你下定义。",
  },
  {
    icon: "ri-emotion-line",
    title: "把情绪和信息分开",
    desc: "争议焦点与当事方回应分列，减少评论区互撕对判断的干扰。",
  },
  {
    icon: "ri-refresh-line",
    title: "错了就改",
    desc: "发现内容有误会及时更正，并在页面上保留更正说明。",
  },
];

export const stats: { value: string; label: string }[] = [
  { value: "1,200+", label: "累计追踪事件" },
  { value: "4,600+", label: "梳理关键节点" },
  { value: "860+", label: "完成辟谣核查" },
  { value: "98%", label: "更新及时率" },
];